<script>
import { mapState } from 'vuex'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'

export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout,  CardLine1ChartExample },
  computed: {
    ...mapState('auth', {
      loggedUser: (state) => state.currentUser.user,
    })
  },
}
</script>

<template>
  <Layout>
    <div class="page-content">
      <div class="container">
        <b-row>
           <b-col sm="12" md="6" lg="3">
                <b-card no-body class="md-card" style="margin-bottom: 30px;">
                  <b-card-body class="pb-10">
                    <div class="hpanel">
                          <div class="panel-body text-center h-200">
                         
                              <font-awesome-icon icon="chart-line" size="3x"  class="icon alt" />

                              <h1 class="large-text f-thin tm-10">$1 206,90</h1>

                              <h3 class="medium-text f-bold no-margins text-success">
                                  All Income
                              </h3>
                              <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit vestibulum.</small>
                          </div>
                      </div>
                     </b-card-body>
                </b-card>
          </b-col>

           <b-col sm="12" md="6" lg="3">
                <b-card no-body class="md-card" style="margin-bottom: 30px;">
                  <b-card-body class="pb-10">
                      <div class="hpanel stats">
                        <div class="panel-body h-200">
                            <div class="card-title pull-left">
                                <h4>Users Activity</h4>
                            </div>
                            <div class="stats-icon pull-right">
                               <font-awesome-icon icon="project-diagram" size="2x"  class="icon alt" />
                            </div>
                            <div class="m-t-xl clearfix">
                                <h3 class="tm-10">210</h3>
                                <span class="font-bold no-margins">
                                    Social users
                                </span>

                                <div class="progress m-t-xs full progress-small">
                                    <div style="width: 55%" aria-valuemax="100" aria-valuemin="0" aria-valuenow="55" role="progressbar" class=" progress-bar progress-bar-success">
                                        <span class="sr-only">35% Complete (success)</span>
                                    </div>
                                </div>

                                <b-row class="m-t-xs">
                                     <b-col xs="6">
                                        <small class="stats-label">Pages / Visit</small>
                                        <h4 class="tm-5 medium-text">7.80</h4>
                                    </b-col>

                                    <b-col xs="6">
                                        <small class="stats-label">% New Visits</small>
                                        <h4 class="tm-5 medium-text">76.43%</h4>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                     </b-card-body>
                </b-card>
          </b-col>

          <b-col sm="12" md="6" lg="6">
                <b-card no-body class="md-card" style="margin-bottom: 30px;">
                  <b-card-body class="pb-10">
                    <div class="hpanel stats">
                        <div class="panel-body h-200">
                            <div class="card-title pull-left">
                                <h4>Today income</h4>
                            </div>
                            <div class="stats-icon pull-right">
                              <font-awesome-icon icon="coins" size="2x"  class="icon alt" />
                            </div>
                            <div class="clearfix"></div>
                            <div class="flot-chart">
                                 <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:97px;" :height="97"/>
                            </div>
                            <div class="m-t-xs">

                                  <b-row>
                                    <b-col xs="6">
                                        <small class="stat-label">Today</small>
                                        <h4 class="tm-5 medium-text">$230,00 </h4>
                                    </b-col>
                           
                                    <b-col xs="6">
                                        <small class="stat-label">Last week</small>
                                        <h4 class="tm-5 medium-text">$7 980,60 <i class="fab fa-level-up text-success"></i></h4>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                     </b-card-body>
                </b-card>
          </b-col>

        </b-row>
        <b-row>
              <b-col sm="6" lg="3">
                <b-card no-body class="md-card" style="margin-bottom: 30px;">
                  <b-card-body class="pb-0">
                    <b-dropdown class="float-right" variant="transparent p-0" right>
                      <template slot="button-content">
                        <i class="icon-settings"></i>
                      </template>
                      <b-dropdown-item>Action</b-dropdown-item>
                      <b-dropdown-item>Another action</b-dropdown-item>
                      <b-dropdown-item>Something else here...</b-dropdown-item>
                      <b-dropdown-item disabled>Disabled action</b-dropdown-item>
                    </b-dropdown>
                    <h4 class="mb-0">9.823</h4>
                    <p>Members online</p>
                  </b-card-body>
                  <!-- <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/> -->
                </b-card>
              </b-col>
              <b-col sm="6" lg="3">
                <b-card no-body class="md-card" style="margin-bottom: 30px;">
                  <b-card-body class="pb-0">
                    <b-dropdown class="float-right" variant="transparent p-0" right no-caret>
                      <template slot="button-content">
                        <i class="icon-location-pin"></i>
                      </template>
                      <b-dropdown-item>Action</b-dropdown-item>
                      <b-dropdown-item>Another action</b-dropdown-item>
                      <b-dropdown-item>Something else here...</b-dropdown-item>
                      <b-dropdown-item disabled>Disabled action</b-dropdown-item>
                    </b-dropdown>
                    <h4 class="mb-0">9.823</h4>
                    <p>Members online</p>
                  </b-card-body>
                  <!-- <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/> -->
                </b-card>
              </b-col>
              <b-col sm="6" lg="3">
                <b-card no-body class="md-card" style="margin-bottom: 30px;">
                  <b-card-body class="pb-0">
                    <b-dropdown class="float-right" variant="transparent p-0" right>
                      <template slot="button-content">
                        <i class="icon-settings"></i>
                      </template>
                      <b-dropdown-item>Action</b-dropdown-item>
                      <b-dropdown-item>Another action</b-dropdown-item>
                      <b-dropdown-item>Something else here...</b-dropdown-item>
                      <b-dropdown-item disabled>Disabled action</b-dropdown-item>
                    </b-dropdown>
                    <h4 class="mb-0">9.823</h4>
                    <p>Members online</p>
                  </b-card-body>
                  <!-- <card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/> -->
                </b-card>
              </b-col>
              <b-col sm="6" lg="3">
                <b-card no-body class="md-card" style="margin-bottom: 30px;">
                  <b-card-body class="pb-0">
                    <b-dropdown class="float-right" variant="transparent p-0" right>
                      <template slot="button-content">
                        <i class="icon-settings"></i>
                      </template>
                      <b-dropdown-item>Action</b-dropdown-item>
                      <b-dropdown-item>Another action</b-dropdown-item>
                      <b-dropdown-item>Something else here...</b-dropdown-item>
                      <b-dropdown-item disabled>Disabled action</b-dropdown-item>
                    </b-dropdown>
                    <h4 class="mb-0">9.823</h4>
                    <p>Members online</p>
                  </b-card-body>
                  <!-- <card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/> -->
                </b-card>
              </b-col>
            </b-row>
      </div>
    </div>
  </Layout>
</template>
